import { render, staticRenderFns } from "./UnitProductCreateModal.vue?vue&type=template&id=efac2d20&scoped=true"
import script from "./UnitProductCreateModal.vue?vue&type=script&lang=js"
export * from "./UnitProductCreateModal.vue?vue&type=script&lang=js"
import style0 from "./UnitProductCreateModal.vue?vue&type=style&index=0&id=efac2d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efac2d20",
  null
  
)

export default component.exports